import { Button } from '@cian/ui-kit';
import * as style from './Failed.css';
import clsx from 'clsx';

interface IFailedProps {
  onBackToForm: VoidFunction;
  isBanner?: boolean;
}

export const Failed: React.FC<IFailedProps> = ({ onBackToForm, isBanner = false }) => {
  return (
    <div className={clsx(style['container'], isBanner && style['banner'])}>
      <div className={style['wrapper']}>
        <div className={style['title']}>
          Произошла непредвиденная ошибка. <br /> Попробуйте позже.
        </div>
        <Button onClick={onBackToForm}>Вернуться на форму</Button>
      </div>
    </div>
  );
};
